/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class IsProxy extends RiskFactor {
    icon = 'close-s';

    className = 'icon-red';

    label = 'Order Placed From';

    result = 'Proxy';

    static getCondition({isProxy}) {
        return !!isProxy;
    }

    parse({isProxy}) {
        this.isProxy = isProxy;
    }

    getResult() {
        return this.result;
    }
}
